export const AGENCY = '/agency'
export const AGENCY_CREATE = '/agency/create'
export const AGENCY_EDIT = '/agency/:id/edit'
